module.exports = __webpack_public_path__ + "static/img/6.3c4770a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/flag_icons/6.png
// module id = jPwE
// module chunks = 1